<template>
  <div class="another-driver-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Another Driver Section -->
    <section class="another-driver-section">
      <div class="container">
        <div class="another-driver-content">
          <div class="driver-count" v-if="driverCount > 0">
            {{ driverCount }} driver{{ driverCount > 1 ? 's' : '' }} selected
          </div>
          <div class="driver-title">
            <h1>Add another driver?</h1>
            <p>(Save Additional 20%)</p>
          </div>
          
          <div class="driver-options">
            <button 
              :class="['driver-btn', { 'selected': selectedOption === 'Yes' }]"
              @click="selectOption('Yes')"
            >
              Yes
            </button>
            <button 
              :class="['driver-btn', { 'selected': selectedOption === 'No' }]"
              @click="selectOption('No')"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'AnotherDriverPage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      userQuoteData: null,
      selectedOption: null
    }
  },
  computed: {
    driverCount() {
      // 计算已选择的驾驶员数量：主驾驶员(1) + 其他驾驶员
      let count = 1 // 主驾驶员
      if (this.userQuoteData && this.userQuoteData.other_drivers) {
        count += this.userQuoteData.other_drivers.length
      }
      return count
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有姓名信息
          if (!this.userQuoteData.first_name || !this.userQuoteData.last_name) {
            // 如果没有姓名信息，跳转回name页面
            this.$router.push('/name')
            return
          }
          // 加载之前选择的选项（如果有的话）
          if (this.userQuoteData.add_another_driver !== undefined) {
            this.selectedOption = this.userQuoteData.add_another_driver
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectOption(option) {
      this.selectedOption = option
      
      // 更新用户数据
      this.userQuoteData.add_another_driver = option
      this.saveUserData()
      
      console.log('Selected add another driver:', option)
      
      // 根据选择跳转到不同页面
      if (option === 'Yes') {
        // 如果选择Yes，初始化额外驾驶员流程
        console.log('User wants to add another driver')
        
        // 确保other_drivers数组存在
        if (!this.userQuoteData.other_drivers) {
          this.userQuoteData.other_drivers = []
        }
        
        // 设置添加驾驶员模式
        this.userQuoteData.adding_driver = true
        this.userQuoteData.temp_driver = {
          first_name: '',
          last_name: '',
          relationship: '',
          gender: '',
          marital_status: '',
          birthday: '',
          birth_month: '',
          birth_day: '',
          birth_year: ''
        }
        
        this.saveUserData()
        
        // 提交数据并记录页面提交事件
        await submitDataAndLog('anotherdriver')
        // 跳转到gender页面开始驾驶员信息流程
        this.$router.push('/gender')
      } else {
        // 提交数据并记录页面提交事件
        await submitDataAndLog('anotherdriver')
        // 如果选择No，跳转到Current Address页面
        this.$router.push('/current-address')
        console.log('User does not want to add another driver')
      }
    },
    
    goBack() {
      this.$router.push('/name')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.another-driver-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Another Driver Section */
.another-driver-section {
  padding: 4rem 0;
  background: #fff;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.another-driver-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 2rem;
}

.driver-title h1 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.driver-count {
  color: #28a745;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.driver-title p {
  font-size: 1.3rem;
  color: #666;
  margin-bottom: 3rem;
}

.driver-options {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.driver-btn {
  padding: 1.5rem 3rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.driver-btn:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.driver-btn.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .another-driver-content {
    padding: 0 1rem;
  }

  .driver-title h1 {
    font-size: 2rem;
  }

  .driver-title p {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }

  .driver-options {
    gap: 1rem;
  }

  .driver-btn {
    flex: 1;
    max-width: 150px;
    padding: 1.2rem 1.5rem;
    font-size: 1.3rem;
  }
}

@media (max-width: 480px) {
  .another-driver-content {
    padding: 0 0.5rem;
  }

  .driver-title h1 {
    font-size: 1.8rem;
  }

  .driver-title p {
    font-size: 1rem;
  }

  .driver-options {
    gap: 0.8rem;
  }

  .driver-btn {
    flex: 1;
    max-width: 120px;
    padding: 1rem 1rem;
    font-size: 1.2rem;
  }
}
</style>
